












































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { DateRange } from "vuetify-daterange-picker";
import { IUploadFile } from "@/components/shared/types";
import UploadUI from "@/components/shared/UploadFileUI.vue";
import { User } from "@/components/User";
import { INewsContents, NewsContents, News } from "@/components/News";
import { Paragraph } from "@/components/Paragraph";
import { createDate, DateOfNMonthsBefore } from "@/common/utils";
import { L } from "@/common/filters";

const TODAY = new Date();
const THIS_DATE = TODAY.toISOString().substr(0,10);
const LAST_1MONTH = DateOfNMonthsBefore(1,TODAY).toISOString().substr(0,10);
const LAST_6MONTH = DateOfNMonthsBefore(6,TODAY).toISOString().substr(0,10);
const NEXT_1MONTH = DateOfNMonthsBefore(-1,TODAY).toISOString().substr(0,10);

@Component({
  components: {
    'v-daterange': DateRange,
    'file-upload': UploadUI
  }
})
export default class AddNewsUI extends Vue {
  news:News = new News();
  ShowDateRange: boolean = false;
  DateRange:Date[] = null;
  Contents:NewsContents[] = [new NewsContents()];

  get User() : User {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.User.Language;
  }

  get locale() : string {
    let lang = this.language;
    return lang=='th' ? 'th-th' : lang=='zh' ? 'zh-cn' : 'en-us';
  }

  get rules() {
    return {
      required: value => {
        value = value ? (value+'').trim() : null;
        return !!value || L('required');
      }
    }
  }
  
  dateRangeOptions = {
    minDate: LAST_1MONTH,
    maxDate: NEXT_1MONTH,
    startDate: LAST_1MONTH,
    endDate: THIS_DATE,
    format: this.language=='th' ? 'DD/MM/YYYY' : this.language=='zh' ? 'YYYY/MM/DD' : 'MM/DD/YYYY',
    presets: null
  };

  dateRangeLabels = {
    start: L('startDate'),
    end: L('endDate'),
    presets: ''
  }

  onDateRangeChange(range) {
  }

  get Backdrop() : boolean {
    return this.$store.getters.ShowBackdrop;
  }
  
  lastDateRange:string[] = null; //used to rollback in case that date range is cancelled
  set Backdrop(show:boolean) {
    if (show) {
      let dr:any = this.$refs["DateRange"];
      this.lastDateRange = [
        dr.startDate, dr.endDate
      ];
    }
    this.$store.commit('notifyChange', {
      ShowBackdrop: show
    });
  }

  setDateRange() {
    let dr:any = this.$refs["DateRange"];
    let start = createDate(dr.startDate);
    let end = createDate(dr.endDate);
    if (dr.startDate==dr.endDate) {
      this.DateRange = [ start ];
    } else {
      this.DateRange = [ start, end ];
    }
    this.Backdrop = false;
    this.ShowDateRange = false;
    this.news.DateStart = start;
    this.news.DateEnd = end;
  }

  cancelDateRange() {
    let dr:any = this.$refs["DateRange"];
    dr.startDate = this.lastDateRange[0];
    dr.endDate = this.lastDateRange[1];
    this.Backdrop = false;
    this.ShowDateRange = false;
  }
  
  addPhotos(event) {
    this.Contents[event.index].addPhotos(event.files);
  };

  removePhoto(event) {
    this.Contents[event.index].removePhoto(event.file);
  };

  addContent(index:number) {
    this.Contents.splice(index+1, 0, new NewsContents());
    /*
    let p:Paragraph = new Paragraph();
    p.Text = this.Contents;
    p.File = this.Photos[0].file;
    this.news.Contents = this.news.Contents || [];
    this.news.Contents.push(p);
    this.Photos = [];
    this.Contents = '';*/
  }

  removeContent(index:number) {
    if (this.Contents.length>1) {
      this.Contents.splice(index,1);
    } else {
      this.Contents = [new NewsContents()];
    }
  }

  hasValidInput() {
    let v:boolean = false;
    for (let i=0; i<this.Contents.length && !v; i++) {
      v = this.Contents[i].isValid();
    }
    return this.news.hasValidInput() && v;
  }

  async submit() {
    try {
      await this.news.save(this.User);
      this.Contents.forEach((content,index) => {
        content.upload(this.User.Code, parseInt(this.news.HalloId));
      });
    } catch (error) {
    }
  }
  
  onUploadComplete(event) {
    let index = event.index;
    this.Contents[index].Upload = false;
    //this.$nextTick(() => {
      let i, uploading = false;
      for (i=0; i<this.Contents.length; i++) {
        uploading = uploading || this.Contents[i].Upload;
        if (uploading) { break; }
      }
      if (!uploading) {
        this.$store.commit('notifyChange', {
          SelectedApp: 'news'
        });
      }
    //});
  }
}
